var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMuseum = function SvgMuseum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80-80v-80h80v-360H80v-80l400-280 400 280v80h-80v360h80v80zm160-80h480zm80-80h80v-160l80 120 80-120v160h80v-280h-80l-80 120-80-120h-80zm400 80v-454L480-782 240-614v454z"
  })));
};
export default SvgMuseum;